import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Linkify from "react-linkify";
import Avatar from "module-common/Avatar";
import IconRaw from "module-common/Icon";
import BubbleOption from "./BubbleOptionWithStoreMutation";
import LabelList from "./TreeLabelListStreamWithQueryMutation";
import Gallery from "react-grid-gallery";
import moment from "moment";

export default class Bubble extends Component {
  static propTypes = {
    id: PropTypes.number,
    content: PropTypes.string,
    fromAgent: PropTypes.bool,
    withArrow: PropTypes.bool,
    showOption: PropTypes.bool,
    showOptionMenu: PropTypes.bool,
    time: PropTypes.string,
    avatar: PropTypes.string,
    noNeed: PropTypes.bool,
    imageUrl: PropTypes.string,
    imageContext: PropTypes.string,
    channelHandlerCompany: PropTypes.string,
    contentCompany: PropTypes.string,
    timeCompany: PropTypes.instanceOf(moment),
    channelType: PropTypes.string,
    replyImage: PropTypes.string,
    channelName: PropTypes.string,
    originalPost: PropTypes.string,
    sentByName: PropTypes.string,
  };

  static defaultProps = {
    content: "",
    time: "",
    timeCompany: "",
    fromAgent: false,
    withArrow: false,
    withTime: false,
    noNeed: false
  };

  render() {
    const props = this.props;
    const IMAGES = [
      {
        src: props.imageUrl,
        thumbnail: props.imageUrl,
        thumbnailWidth: 120,
        thumbnailHeight: 0
      }
    ];
    const IMAGESCONTEXT = [
      {
        src: props.imageContext,
        thumbnail: props.imageContext,
        thumbnailWidth: 120,
        thumbnailHeight: 0
      }
    ];
  
    return (
      <Wrapper>
        <InnerWrapper fromAgent={props.fromAgent}>
          <AvatarSpace>
            {props.fromAgent && props.avatar && <TailAgent />}
            {props.avatar && <Avatar image={props.avatar} isSmall />}
            {!props.fromAgent && props.avatar && <TailCustomer />}
          </AvatarSpace>
          <RightColumn>
            <BubbleWrapper fromAgent={props.fromAgent}>
              {props.imageUrl && (
                <Image>
                  <Gallery images={IMAGES} enableImageSelection={false} />
                </Image>
              )}

              {props.showOption &&
                props.imageContext && (
                  <ImgAccount>
                    <Image>
                      <Gallery
                        images={IMAGESCONTEXT}
                        enableImageSelection={false}
                      />
                    </Image>

                    <RightAccount>
                      <p>
                        <ChannelHandler>
                          {props.channelHandlerCompany}
                        </ChannelHandler>
                        <Linkify>
                          {props.contentCompany !== null &&
                          props.contentCompany.length >= 60
                            ? props.contentCompany.slice(0, 60) + " [...]"
                            : props.contentCompany}
                        </Linkify>
                      </p>
                      <TimePublish>
                        <p>
                          {props.timeCompany.format("LL")} | {}
                          {props.timeCompany.format("hh:mm A")}
                        </p>
                      </TimePublish>
                    </RightAccount>
                  </ImgAccount>
                )}

              {props.replyContent && (
                <ReplyBubble>
                  <ReplyContent>
                    {/* <Image>
                      <Gallery
                        images={IMAGESREPLY}
                        enableImageSelection={false}
                      />
                    </Image> */}
                    <RightAccount>
                      <ReplyName>{props.replyName}</ReplyName>
                      <Linkify>{props.replyContent}</Linkify>
                    </RightAccount>
                  </ReplyContent>
                </ReplyBubble>
              )}

              <Linkify>{props.content}</Linkify>
              {props.showOption && (
                <StyledBubbleOption
                  noNeed={props.noNeed}
                  id={props.id}
                  content={props.content}
                  fromAgent={props.fromAgent}
                  white={props.fromAgent}
                  channelType={props.channelType}
                  channelName={props.channelName}
                  url={props.originalPost}
                  showOptionMenu={props.showOptionMenu}
                  channelTypeId={props.channelTypeId}
                />
              )}
              <StyledLabelList
                id={props.id}
                labels={props.labels}
                editable={props.showOption}
              />
              {props.noNeed && <Icon name="no-need" />}
            </BubbleWrapper>
            <Footer>
              {props.channelType && (
                <ChannelType>{props.channelType} {props.sentByName && `by ${props.sentByName}`} </ChannelType>
              )}
              {props.time && (
                <Time fromAgent={props.fromAgent}>{props.time}</Time>
              )}
            </Footer>
          </RightColumn>
        </InnerWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
`;
const InnerWrapper = styled.div`
  display: flex;
  flex: none;
  flex-direction: ${props => (props.fromAgent ? "row-reverse" : "row")};
  align-items: center;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const AvatarSpace = styled.div`
  display: flex;
  justify-content: center;
  flex: none;
  width: 40px;
  margin: 0 5px;
`;
const TailAgent = styled.div`
  &:after {
    content: " ";
    position: absolute;
    border: 6px solid;
    margin-top: 7px;
    margin-left: -12px;
    border-left-color: ${props => props.theme.blueButton};
    border-right-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
  }
`;
const TailCustomer = styled.div`
  &:before {
    content: " ";
    position: absolute;
    border: 6px solid;
    margin-top: 7px;
    border-color: transparent #a5a5a5 transparent transparent;
  }
  &:after {
    content: " ";
    position: absolute;
    border: 6px solid;
    margin-left: 1.7px;
    margin-top: 7px;
    z-index: 1;
    border-color: transparent white transparent transparent;
  }
`;
const BubbleWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  padding: 15px;
  border-radius: 8px;
  max-width: 380px;
  border: 1px solid ${props => props.theme.headerButtonBorder};
  font-size: 0.9rem;
  ${props =>
    props.fromAgent &&
    css`
      background-color: ${props.theme.blueButton};
      color: #eef1f5;
      border: none;
      & a {
        color: #eef1f5;
        text-decoration: underline;
      }
    `};
`;
const ReplyBubble = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 4px;
  min-width: 300px;
`;
const ReplyName = styled.div`
  color: #338ac7;
  font-weight: bold;
`;
const ReplyContent = styled.div`
  color: ${props => props.theme.uiText};
`;
const StyledBubbleOption = styled(BubbleOption)`
  position: absolute;
  top: 2px;
  ${props => (props.fromAgent ? "left: 4px;" : "right: 4px;")};
`;
const Icon = styled(IconRaw)`
  position: absolute;
  right: 4px;
  bottom: 4px;
`;
const ChannelType = styled.span`
  margin-top: 4px;
  font-size: 0.7rem;
`;
const Time = styled.span`
  margin-top: 4px;
  font-size: 0.7rem;
  margin-left: auto;
`;

/*   const Image = styled.image`
//   width: 260px;
//   height: 100px;
//   // margin-bottom: 4px;
//   // cursor: pointer;
//   background-position: center;
//   // background-repeat: no-repeat;
//   // background-size: contain;
//   &:hover {
//     opacity: 0.7;
//   }
//   // ${props => props.url && css`background-image: url(${props.url});`};

// `; */
const Image = styled.image`
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 15px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  & img {
    max-width: 80px;
    max-height: 80px;
    border-radius: 8px;
  }
  &:hover {
    opacity: 0.7;
  }
`;
const StyledLabelList = styled(LabelList)`
  margin-top: 4px;
`;
const ImgAccount = styled.div`
  height: 95px;
  min-width: 300px;
`;
const ChannelHandler = styled.b`
  font-weight: bold;
  padding-right: 2px;
`;
const RightAccount = styled.div`
  display: flex;
  flex: 2 0;
  color: grey;
  flex-direction: column;
  padding-left: 15px;
`;
const TimePublish = styled.div`
  display: flex;
  margin-top: 18px;
  padding-bottom: 7px;
  border-bottom: dotted 1px grey;
  font-size: 0.8rem;
`;

const Pre = styled.div`
  white-space:pre;
`



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/message-list/bubble/Bubble.js